import * as PropTypes from 'prop-types'
import { Motion, spring } from 'react-motion'

import { getAbsoluteTopOfElement } from '/javascripts/utils/getAbsoluteTopOfElement'
import { MOTION_PRESETS } from '/react/constants/motionPresets'

export class AnimatedPageScroll extends React.PureComponent {
  static propTypes = {
    offset: PropTypes.number,
    onRest: PropTypes.func,
    scrollToTarget: PropTypes.any.isRequired // Should be 'instanceOf(Element)', but Element is not available when rendering server side.
  }

  static defaultProps = {
    offset: 0
  }

  state = {
    isWaiting: true
  }

  springConfig = MOTION_PRESETS.FAST

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        isWaiting: false
      })
    })
  }

  render () {
    const {
      offset,
      onRest,
      scrollToTarget
    } = this.props

    const {
      isWaiting
    } = this.state

    if (isWaiting || !scrollToTarget) return null

    const scrollTo = getAbsoluteTopOfElement(scrollToTarget) + offset

    return (
      <Motion
        defaultStyle={{
          scrollTop: window.pageYOffset
        }}
        style={{
          scrollTop: spring(scrollTo, this.springConfig)
        }}
        onRest={onRest}
      >
        {(interpolatedStyle) => {
          window.scrollTo(0, interpolatedStyle.scrollTop)
          return null
        }}
      </Motion>
    )
  }
}
